// src/config/apollo.js
import { ApolloClient, InMemoryCache } from "@apollo/client";
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";
import { setContext } from "@apollo/client/link/context";
import {getToken} from "../utils/token"

const authLink = setContext((_, { headers }) => {
  const token = getToken();
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});
const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(new UploadHttpLink({
    //uri: "http://localhost:4000/graphql",
    uri:"https://api.zilacat.com/graphql",
    headers: {
      "Apollo-Require-Preflight": "true",
    },
  })),
  connectToDevTools: true,
});

export default client;
